import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.primary.dark,
        color: 'white',
        py: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mb: 2 }} />
        <Typography 
          variant="body2" 
          align="center"
          sx={{ 
            opacity: 0.8,
            '& span': {
              color: theme.palette.secondary.light,
              fontWeight: 600,
            }
          }}
        >
          Desenvolvido por <span>Renato Luiz de Almeida</span> e <span>Carlos Guilherme Ferreira</span> - 
          Todos os direitos reservados © 2026
        </Typography>
        <Typography 
          variant="caption" 
          align="center"
          sx={{ 
            display: 'block', 
            mt: 1, 
            opacity: 0.6 
          }}
        >
          Sistema de Consulta de Valores Devidos (Ação do 1/3 de Férias) - Versão 1.0.0
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;